<app-header></app-header>
<app-profile-header></app-profile-header>
<app-right-side></app-right-side>
<link
rel="stylesheet"
data-purpose="Layout StyleSheet"
title="Web Awesome"
href="/css/app-wa-86cd56275caec687041f80b17dc62e32.css?vsn=d"
>

<link
  rel="stylesheet"
  href="https://site-assets.fontawesome.com/releases/v5.15.4/css/all.css"
>

<script async src="https://www.googletagmanager.com/gtag/js?id=G-BPMS41FJD2"></script>
<div *ngIf="language !='ar'" class="container">    
    <div class="row" style="border: 1px solid #ffffff; background-color: #aaaaaa; padding: 5px; height: 150px;">
        <div class="col col-xl-2 col-lg-4 col-md-4 col-sm-4 col-12" style="top:-80px">
            <div class="ui-block" data-mh="friend-groups-item" style="background-color: #093952;">
                <div class="friend-item friend-groups">
                    <div class="friend-item-content">
                        <a routerLink="/executive-committee"> <img src="assets/img/iffhs-member.png" style="height: auto;" alt="IFFHS Members"> </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col col-xl-2 col-lg-4 col-md-4 col-sm-4 col-12" style="top:-80px">
            <div class="ui-block" data-mh="friend-groups-item"  style="background-color: #093952;">
                <div class="friend-item friend-groups">
                    <div class="friend-item-content">
                        <a routerLink="/associations"> <img src="assets/img/associations.png" style="height: auto;"
                                alt="associations"> </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col col-xl-2 col-lg-4 col-md-4 col-sm-4 col-12" style="top:-80px;">
            <div class="ui-block" data-mh="friend-groups-item"  style="background-color: #093952;">

                <div class="friend-item friend-groups">

                    <div class="friend-item-content">
                        <a routerLink="/teams"> <img src="assets/img/football-teams.png" style="height: auto;"
                                alt="football teams"> </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col col-xl-2 col-lg-4 col-md-4 col-sm-4 col-12" style="top:-80px">
            <div class="ui-block" data-mh="friend-groups-item"  style="background-color: #093952;">

                <div class="friend-item friend-groups">

                    <div class="friend-item-content">
                        <a routerLink="/media"> <img src="assets/img/media1.png" style="height: auto;"
                                alt="football media"> </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col col-xl-2 col-lg-4 col-md-4 col-sm-4 col-12" style="top:-80px">
            <div class="ui-block" data-mh="friend-groups-item"  style="background-color: #093952;">

                <div class="friend-item friend-groups">

                    <div class="friend-item-content">
                        <a routerLink="/general-assembly"> <img src="assets/img/g-assembly.png" style="height: auto;"
                                alt="general-assembly"> </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col col-xl-2 col-lg-4 col-md-4 col-sm-4 col-12" style="top:-80px">
            <div class="ui-block" data-mh="friend-groups-item"  style="background-color: #093952;">

                <div class="friend-item friend-groups">

                    <div class="friend-item-content">
                        <a routerLink="/fans"> <img src="assets/img/fans1.png" style="height: auto;" alt="Fans"> </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12" style="top:-80px">
            <div class="ui-block row" style="background-color: var(--backgroundpost-color); color: var(--text-color); ">
                <div class="ui-block-title">
                    <h6 class="label-title" style="background-color: var(--backgroundpost-color); color: var(--text-color); top: 0px;">
                        <img src="https://iffhs.com/assets/images/logo.png" style="width: 50px; top:10px;  position: relative; ">&nbsp;IFFHS.COM | LAST NEWS</h6>
                </div>
                <div *ngFor="let items of posts2.data; let i = index" class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                    <div class="movie-box-2">
                    <div class="numberheader"><i class="fad fa-eye" style="color: #cccccc; "></i>&nbsp; {{getformat(items.views)}} 
                        <span style="border-right:2px solid rgba(255, 255, 255, 0.7); color:rgb(255, 255, 255)">&nbsp;</span>&nbsp;
                        <i class="fad fa-comments" style="color: #cccccc;"></i>&nbsp;{{items.postcom}} </div>
                        <!--<a href="https://iffhs.com/posts/{{items.id}}" target="_blank">-->
                        <a routerLink="/Iffhsposts" [queryParams]="{'id': items.id}"> 
                        <div class="listing-image"><img src="https://iffhs.com/storage/img/posts/{{items.image}}"></div>
                        <div class="h5" style="color: #ffffff; height: 50px; padding: 10px;">{{items.title}}</div><br>
                        <div style="font-size: 15px; color:rgba(255, 255, 255, 0.7); padding-left: 15px;">{{calculateDiff(items.created_at)}}</div>
                        <div class="categories" style="color:#ffffff; padding: 5px; font-size: 12px;"><i class="fad fa-tags" style="color:#cccccc;"></i>&nbsp;{{items.name}}</div>
                        <hr style="background-color:rgb(8 66 89);">
                        <div class="h5" style="color:#fff; padding: 10px; font-size: 18px; text-align: right;">
                            &nbsp;
                        </div>
                    </a></div>
                </div>
        </div></div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12" style="top:-80px">
            <div class="ui-block row" style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                <div class="ui-block-title">
                    <h6 class="label-title" style="background-color: var(--backgroundpost-color); color: var(--text-color);"><i class="fad fa-futbol" style="color: #af5912;"></i>&nbsp;CLUBS | NEWS & BLOGS</h6>
                </div>
                <div *ngFor="let item of Clubnews" class="col-xl-4 col-lg-4 col-md-6 col-sm-12" style="padding: 15px; text-align: center; border-bottom: 1px solid #e4e4e4; border-right: 1px solid #e4e4e4;">
                    <div class="movie-box-2">
                    <a class="read" href="javascript:void(0);" (click)="openModal(newsModal,item)">
                    <div class="clubcss" *ngIf="item.type == 'Blog'"><i class="fad fa-tags"></i>&nbsp;{{item.type}}</div>
                    <div class="clubcss2" *ngIf="item.type !== 'Blog'"><i class="fad fa-tags"></i>&nbsp;{{item.type}}</div>
                    <div class="listing-image"><img src="{{item.newsAttachment}}" class="img-flui1d"></div>
                    <div class="h5" style="color: #ffffff; height: 50px; padding: 10px;">{{item.newsTitle}}</div>
                    <div style="font-size: 15px; color:#fff; padding-left: 15px; text-align: left;">{{calculateDiff(item.created_at)}}</div>
                    <br>
                    </a>
                    </div>
                </div>
                
        </div></div>
        <footer class="bg-body-tertiary text-center text-lg-start" style="text-align: center; width: 100%; background-color: var(--backgroundpost-color); color: var(--text-color);">
            <!-- Copyright -->
            <div class="text-center p-3">
              © 2025 Copyright
              <a class="text-body" href="https://footbal-family.com/">Football-Family.com</a>
            </div>
            <!-- Copyright -->
          </footer>
    </div>
</div>
<div *ngIf="language =='ar'" class="container">
    <div class="row" style="border: 1px solid #ffffff; background-color: #aaaaaa; padding: 5px; height: 150px;">
        <div class="col col-xl-2 col-lg-4 col-md-6 col-sm-6 col-12"  style="top:-80px">
            <div class="ui-block" data-mh="friend-groups-item"  style="background-color: #093952;">
                <div class="friend-item friend-groups">
                    <div class="friend-item-content">
                        <a routerLink="/fans"> <img src="assets/img/{{language}}/fans1.png" style="height: auto;" alt="Fans"> </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col col-xl-2 col-lg-4 col-md-6 col-sm-6 col-12"  style="top:-80px">
            <div class="ui-block" data-mh="friend-groups-item" style="background-color: #093952;">
                <div class="friend-item friend-groups">
                    <div class="friend-item-content">
                        <a routerLink="/media"> <img src="assets/img/{{language}}/media1.png" style="height: auto;"
                                alt="football media"> </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col col-xl-2 col-lg-4 col-md-6 col-sm-6 col-12"  style="top:-80px">
            <div class="ui-block" data-mh="friend-groups-item" style="background-color: #093952;">
                <div class="friend-item friend-groups">
                    <div class="friend-item-content">
                        <a routerLink="/general-assembly"> <img src="assets/img/{{language}}/g-assembly.png"
                                style="height: auto;" alt="general-assembly"> </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col col-xl-2 col-lg-4 col-md-6 col-sm-6 col-12"  style="top:-80px">
            <div class="ui-block" data-mh="friend-groups-item" style="background-color: #093952;">

                <div class="friend-item friend-groups">

                    <div class="friend-item-content">
                        <a routerLink="/teams"> <img src="assets/img/{{language}}/football-teams.png"
                                style="height: auto;" alt="football teams"> </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col col-xl-2 col-lg-4 col-md-6 col-sm-6 col-12"  style="top:-80px">
            <div class="ui-block" data-mh="friend-groups-item" style="background-color: #093952;">
                <div class="friend-item friend-groups">
                    <div class="friend-item-content">
                        <a routerLink="/associations"> <img src="assets/img/{{language}}/associations.png"
                                style="height: auto;" alt="associations"> </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col col-xl-2 col-lg-4 col-md-6 col-sm-6 col-12"  style="top:-80px">
            <div class="ui-block" data-mh="friend-groups-item" style="background-color: #093952;">
                <div class="friend-item friend-groups">
                    <div class="friend-item-content">
                        <a routerLink="/executive-committee"> <img src="assets/img/{{language}}/iffhs-member.png"
                                style="height: auto;" alt="IFFHS Members"> </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12" style="top:-80px">
            <div class="ui-block row"  style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                <div class="ui-block-title" >
                    <h6 class="label-title" style="top: 0px; text-align: right; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; background-color: var(--backgroundpost-color); color: var(--text-color);" dir="rtl">
                        <img src="https://iffhs.com/assets/images/logo.png" style="width: 50px; top:10px;  position: relative;">&nbsp;أخر أخبار الموقع الرسمي IFFHS.COM</h6>
                </div>
                <div *ngFor="let items of posts2.data; let i = index" class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                    <div class="movie-box-2">
                    <div class="numberheader"><i class="fad fa-eye" style="color: #cccccc; "></i>&nbsp; {{getformat(items.views)}} 
                        <span style="border-right:2px solid rgba(255, 255, 255, 0.7); color:rgb(255, 255, 255)">&nbsp;</span>&nbsp;
                        <i class="fad fa-comments" style="color: #cccccc;"></i>&nbsp;{{items.postcom}} </div>
                        <!--<a href="https://iffhs.com/posts/{{items.id}}" target="_blank">-->
                        <a routerLink="/Iffhsposts" [queryParams]="{'id': items.id}"> 
                        <div class="listing-image"><img src="https://iffhs.com/storage/img/posts/{{items.image}}"></div>
                        <div class="h5" style="color: #ffffff; height: 50px; padding: 10px;">{{items.title}}</div>
                        <div style="font-size: 15px; color:rgba(255, 255, 255, 0.7); padding-left: 15px;">{{calculateDiff(items.created_at)}}</div>
                        <div class="categories" style="color:#ffffff; padding: 5px; font-size: 12px;"><i class="fad fa-tags" style="color:#cccccc;"></i>&nbsp;{{items.name}}</div>
                        <hr style="background-color:rgb(8 66 89);">
                        <div class="h5" style="color:#fff; padding: 10px; font-size: 18px; text-align: right;">
                            &nbsp;
                        </div>
                    </a></div>
                </div>
        </div></div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12" style="top:-80px">
            <div class="ui-block row" style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                <div class="ui-block-title">
                    <h6 class="label-title" style="color: #1f912e; text-align: right; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; background-color: var(--backgroundpost-color); color: var(--text-color);" dir="rtl"><i class="fad fa-futbol" style="color: #af5912;"></i>&nbsp;مدونات وأخبار الأندية</h6>
                </div>
                <div *ngFor="let item of Clubnews" class="col-xl-4 col-lg-4 col-md-6 col-sm-12" style="padding: 15px; text-align: center; border-bottom: 1px solid #e4e4e4; border-right: 1px solid #e4e4e4;">
                    <div class="movie-box-2">
                    <a class="read" href="javascript:void(0);" (click)="openModal(newsModal,item)">
                    <div class="clubcss" *ngIf="item.type == 'Blog'"><i class="fad fa-tags"></i>&nbsp;{{item.type}}</div>
                    <div class="clubcss2" *ngIf="item.type !== 'Blog'"><i class="fad fa-tags"></i>&nbsp;{{item.type}}</div>
                    <div class="listing-image"><img src="{{item.newsAttachment}}" class="img-flui1d"></div>
                    <div class="h5" style="color: #ffffff; height: 50px; padding: 10px;">{{item.newsTitle}}</div>
                    <div style="font-size: 15px; color:#fff; padding-left: 15px; text-align: left;">{{calculateDiff(item.created_at)}}</div>
                    <br>
                    </a>
                    </div>
                </div>
                
        </div></div>
        <footer class="bg-body-tertiary text-center text-lg-start" style="text-align: center; width: 100%; background-color: var(--backgroundpost-color); color: var(--text-color);">
            <!-- Copyright -->
            <div class="text-center p-3" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; " dir="rtl">
              © جميع الحقوق محفوظة 2025
              <a class="text-body" href="https://footbal-family.com/">Football-Family.com</a>
            </div>
            <!-- Copyright -->
          </footer>
    </div>
</div>
<div class="modal fade" bsModal #newsModal="bs-modal" tabindex="-1" role="dialog" aria-labelledby="private-event"
    aria-hidden="true">
    <div class="modal-dialog window-popup event-private-public private-event" role="document">
        <div class="modal-content">
            <a (click)="closeModal(newsModal)" class="close icon-close" data-dismiss="modal" aria-label="Close">
                <svg class="olymp-close-icon">
                    <use xlink:href="../../../assets/svg-icons/sprites/icons.svg#olymp-close-icon"></use>
                </svg>
            </a>
            <div class="modal-body" style="padding: 5px;">
                <article class="hentry post has-post-thumbnail thumb-full-width private-event" style="border-left: 8px double #aaaaaa;">

                    <div class="private-event-head inline-items">
                        <div class="author-date">
                            <a class="h3 event-title" 
                                href="javascript:void(0);" style="color: #000000; text-align: center;">{{selectNews.newsTitle | titlecase}}</a>
                        </div>
                    </div>
                    <div class="post-thumb" style="width: 80%; margin: 0px auto;">
                        <img src="{{selectNews.newsAttachment}}" alt="photo"
                            onerror="this.onerror=null;this.src='../../../assets/img/clubs.webp';">
                    </div>
                    <div class="row">
                        <div class="col col-lg-12 col-md-12 col-sm-12 col-12">
                            <div class="post__author author vcard inline-items">
                                <div class="event__date">
                                    <time class="published" datetime="2017-03-24T18:18" style="font-size: 12px;">
                                        <i class="fad fa-calendar-alt" style="color:#aaaaaa"></i>&nbsp;{{selectNews.created_at | date:'mediumDate'}}
                                    </time>
                                </div>
                            </div>
                            <p>
                                {{selectNews.newsContent | titlecase}}
                            </p>
                        </div>
                    </div>
                </article>
            </div>
        </div>
    </div>
</div>